/* eslint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

// eslint-disable-next-line react/display-name
const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path stroke="currentColor" strokeWidth="2" d="M11 23h10a2 2 0 002-2V3a2 2 0 00-2-2H11" />
      <path
        fill="currentColor"
        d="M15.707 12.707a1 1 0 000-1.414L9.343 4.929A1 1 0 007.93 6.343L13.586 12l-5.657 5.657a1 1 0 101.414 1.414l6.364-6.364zM0 13h15v-2H0v2z"
      />
    </svg>
  );
});

export const IconLogin24: React.FC<ISVGIconProps> = createIcon(IconComponent);
